import useGlobalModal from "components/GlobalModals/GlobalModalContext/useGlobalModal";
import { INTEGRATIONS_ROUTE } from "pages/Integrations/components/IntegrationSettings/settingConstants";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { selectPostStore } from "store/posts/postSlice";
import { currentBusinessGetter, selectUserInfo } from "store/user/userSlice";

const useHeaderSideEffects = ({
  pathname,
  currentBusiness,
  scheduled,
  user,
  canViewSocialsPage,
  canReadBusiness,
  openGlobalModal,
  navigate,
  defaultBusinessRoute,
}: {
  pathname: string;
  currentBusiness: ReturnType<typeof currentBusinessGetter>;
  scheduled: ReturnType<typeof selectPostStore>["scheduled"];
  user: ReturnType<typeof selectUserInfo>;
  canViewSocialsPage: boolean;
  canReadBusiness: boolean;
  openGlobalModal: ReturnType<typeof useGlobalModal>["openGlobalModal"];
  navigate: ReturnType<typeof useNavigate>;
  defaultBusinessRoute: string;
}) => {
  useEffect(() => {
    const publishedCount =
      currentBusiness?.posts_data?.status_counts?.PUBLISHED ?? 0;

    if (publishedCount + scheduled.count > 2 && user.email === "NO_EMAIL") {
      openGlobalModal({
        modalName: "signup",
      });
    }
  }, [scheduled.count, user, currentBusiness, openGlobalModal]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (
      (pathname === INTEGRATIONS_ROUTE && !canViewSocialsPage) ||
      (!canReadBusiness &&
        ["/topics", "/business", "/branding"].includes(pathname))
    ) {
      navigate(defaultBusinessRoute);
    }
  }, [
    canViewSocialsPage,
    canReadBusiness,
    pathname,
    navigate,
    defaultBusinessRoute,
    INTEGRATIONS_ROUTE, // Ensure INTEGRATIONS_ROUTE is stable or included
  ]);
};

export default useHeaderSideEffects;
